<dgx-search-landing-page
  [defaultFilterIds]="filterIds"
  [filterIdsToIgnore]="filterIdsToIgnore"
  [numberOfFilterSkeletonColumns]="3"
  [title]="'LearningSearch_People' | translate"
  [isLoading]="!hasError && !(data$ | async)"
  [hasError]="hasError"
  [results]="(data$ | async)?.profiles"
  [filters]="(data$ | async)?.filters"
  [totalNumResults]="(data$ | async)?.total"
  [searchOrigin]="searchOrigin"
  [suggestionSource]="suggestionSource"
  [showSearchTabs]="showSearchTabs"
  [useFilterSidebar]="useFilterSidebar"
  (searchTerm)="search$.next($event)"
>
  <ul id="results" class="grid">
    <li
      *ngFor="let user of (data$ | async)?.profiles"
      class="grid__col-xs-6 grid__col-sm-4 grid__col-lg-3"
      [ngClass]="{
        'grid__col-xs-6 grid__col-sm-4 grid__col-lg-4': useFilterSidebar,
        'grid__col-xs-6 grid__col-sm-4 grid__col-lg-3': !useFilterSidebar
      }"
      data-dgat="search-people-view-270"
    >
      <dgx-user-card
        [user]="user"
        location="Search"
        class="tile__wrapper"
      ></dgx-user-card>
    </li>
  </ul>
</dgx-search-landing-page>
